<script>
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import CardContent from '../../UI/Content/CardContent.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import ContractRestructuringFormSelectableContractList from './ContractRestructuringFormSelectableContractList.vue'
import BlockContent from '../../UI/Content/BlockContent.vue'

export default {
  components: { BlockContent, ContractRestructuringFormSelectableContractList, CardContent, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    contractIds: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:contractIds', 'next'],
  data: () => ({
    onlySelectedContracts: false,
  }),
  computed: {
    selectedContractIds: {
      get() {
        return this.contractIds
      },
      set(value) {
        this.$emit('update:contractIds', value)
      },
    },
    atLeastOneContractSelected() {
      return this.selectedContractIds.length > 0
    },
  },
  methods: {
    toggleOnlySelectedContractMode() {
      this.onlySelectedContracts = !this.onlySelectedContracts
    },
    continueWithoutContracts() {
      this.selectedContractIds = []
      this.$emit('next')
    },
  },
}
</script>
<template>
  <BlockContent class="mt-2 px-0">
    <div class="mb-2">
      <div class="d-flex justify-content-between">
        <h6>
          {{ $t('restructuring.fields.contracts.label') }}
          <span class="badge badge-secondary ml-2">{{ selectedContractIds.length }}</span>
        </h6>
        <div class="d-flex justify-content-end">
          <ButtonAll
            type="outline_info"
            margin="no"
            label="restructuring.actions.continueWithoutContracts"
            @click="continueWithoutContracts"
          />
          <ButtonAll
            type="info"
            margin="no"
            :disabled="!atLeastOneContractSelected"
            class="ml-2"
            :label="
              onlySelectedContracts
                ? 'restructuring.list.filters.allContracts'
                : 'restructuring.list.filters.onlySelectedContracts'
            "
            @click="toggleOnlySelectedContractMode"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <CardContent class="pt-3">
          <ContractRestructuringFormSelectableContractList
            ref="contractList"
            v-model:selected-contract-ids="selectedContractIds"
            :only-selected="onlySelectedContracts"
          />
        </CardContent>
      </div>
    </div>
  </BlockContent>
</template>
